import { withPlugins, inview } from '@spon/plugins';

function FadeIn({ node, plugins: { inview } }) {
	/*
	 *		Variables
	 */

	inview.settings = {
		rootMargin: '0px 0px -5% 0px',
		// rootMargin: '0px 0px -40% 0px',
	};

	// watch some other nodes
	inview.observe([...node.querySelectorAll('[data-fade-text]')], {
		enter: ({ target }) => {
			if (!target.classList.contains('has-moved')) {
				target.classList.add('has-moved'); // handled with CSS.
				setTimeout(() => {
					target.removeAttribute('data-fade-text');
				}, 1000);
			}
		},
	});

	inview.observe([...node.querySelectorAll('[data-fade-image]')], {
		enter: ({ target }) => {
			if (!target.classList.contains('has-moved')) {
				target.classList.add('has-moved'); // handled with CSS.
				setTimeout(() => {
					target.removeAttribute('data-fade-image');
				}, 1000);
			}
		},
	});
}
export default withPlugins(inview)(FadeIn);
